// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.trn-register-page {
  padding-bottom: 4rem;
}

.trn-register-hero__body {
  align-items: center;
}

.trn-register-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}

.trn-register-pills span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  color: var(--bv-ink-3);
  font-size: var(--bv-text-sm);
  font-weight: 600;
}

.trn-register-pills i {
  color: var(--bv-primary);
}

.trn-register-section {
  padding: clamp(1.5rem, 4vw, 3rem) 0 0;
}

.trn-register-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.9fr);
  gap: clamp(1.25rem, 3vw, 2rem);
  align-items: start;
}

.trn-register-form {
  display: grid;
  gap: 1.25rem;
}

.trn-register-card {
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  border-radius: 28px;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  box-shadow: var(--bv-shadow-xs);
}

.trn-register-card__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 1.25rem;
}

.trn-register-card__head h2 {
  font-family: var(--bv-font-display);
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin: 0 0 4px;
  color: var(--bv-ink);
}

.trn-register-card__head p {
  margin: 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
}

.trn-register-step {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-weight: 800;
  flex-shrink: 0;
}

/* ---------- Team form ---------- */
.trn-register-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.trn-register-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trn-register-field--file {
  grid-column: 1 / -1;
}

.trn-register-field > label {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
}

.trn-player-grid label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
}

.trn-register-field label i {
  color: var(--bv-primary);
  margin-right: 6px;
}

.trn-register-field label em {
  color: #e11d48;
  font-style: normal;
  margin-left: 4px;
}

.trn-register-field label span {
  margin-left: auto;
  font-weight: 500;
  color: var(--bv-muted-2);
  font-size: 0.75rem;
}

.trn-register-field input,
.trn-player-grid input,
.trn-player-grid select {
  width: 100%;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid #dbe4ea;
  background: #f7fafc;
  color: var(--bv-ink);
  font-weight: 500;
  outline: none;
  transition: border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.trn-register-field input:focus,
.trn-player-grid input:focus,
.trn-player-grid select:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);
  background: #fff;
}

/* red border on the input when its field shows an error */
.trn-register-field:has(.trn-register-error) input,
.trn-player-grid label:has(.trn-register-error) input {
  border-color: #fca5a5;
  background: #fff7f8;
}

.trn-register-upload {
  position: relative;
  min-height: 140px;
  border: 1.5px dashed var(--bv-primary-line);
  border-radius: 20px;
  background: var(--bv-primary-50);
  overflow: hidden;
}

.trn-register-upload input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.trn-register-upload img {
  width: 100%;
  height: 160px;
  object-fit: contain;
  background: #fff;
}

.trn-register-upload__placeholder {
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--bv-primary-700);
}

.trn-register-upload__placeholder i {
  font-size: 1.4rem;
}

.trn-register-add {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--bv-primary-line);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  border-radius: var(--bv-radius-pill);
  font-weight: 700;
  font-size: var(--bv-text-sm);
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.trn-register-add:hover {
  background: #fff;
  transform: translateY(-1px);
}

/* ---------- Legacy player cards (kept for compatibility) ---------- */
.trn-register-players {
  display: grid;
  gap: 1rem;
}

.trn-player-card {
  border: 1px solid var(--bv-line-soft);
  border-radius: 22px;
  padding: 1rem;
  background: linear-gradient(180deg, #fff 0%, #f8fbfb 100%);
}

.trn-player-card.is-captain {
  border-color: var(--bv-primary-line);
  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.08);
}

.trn-player-card header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 1rem;
}

.trn-player-card h3 {
  margin: 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.trn-player-card h3 span {
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.trn-player-card header p {
  margin: 4px 0 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
}

.trn-player-remove {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--bv-line);
  background: #fff;
  color: #e11d48;
}

.trn-player-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.trn-player-role {
  border: 0;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-end;
}

.trn-player-role legend {
  font-size: var(--bv-text-sm);
  font-weight: 700;
  margin-bottom: 8px;
}

.trn-player-role__option {
  display: inline-flex;
  flex-direction: row !important;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 14px;
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
}

/* ---------- Squad list ---------- */
.trn-player-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 2rem 1rem;
  border: 1.5px dashed var(--bv-primary-line);
  border-radius: 20px;
  background: var(--bv-primary-50);
}

.trn-player-empty i {
  font-size: 1.6rem;
  color: var(--bv-primary);
  margin-bottom: 4px;
}

.trn-player-empty h3 {
  margin: 0;
  font-family: var(--bv-font-display);
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--bv-ink);
}

.trn-player-empty p {
  margin: 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
}

.trn-player-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.trn-player-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--bv-line-soft);
  border-radius: 20px;
  background: linear-gradient(180deg, #fff 0%, #f8fbfb 100%);
}

.trn-player-row.is-captain {
  border-color: var(--bv-primary-line);
  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.08);
}

.trn-player-row__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-weight: 800;
}

.trn-player-row__meta {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 2px;
}

.trn-player-row__meta strong {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: var(--bv-ink);
  font-size: 0.95rem;
}

.trn-player-row__meta strong span {
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.trn-player-row__meta small {
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trn-player-row__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.trn-player-row__actions button {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--bv-line);
  background: #fff;
  color: var(--bv-ink-3);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease);
}

.trn-player-row__actions button:hover {
  background: var(--bv-primary-50);
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-700);
}

.trn-player-row__actions button.is-danger {
  color: #e11d48;
}

.trn-player-row__actions button.is-danger:hover {
  background: #fff1f3;
  border-color: #fecdd3;
  color: #be123c;
}

/* ---------- Add / Edit player modal ---------- */
.trn-player-modal {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

/* backdrop is a <button>, so reset native button styles */
.trn-player-modal__backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  cursor: pointer;
  animation: trn-modal-fade 0.2s ease both;
}

.trn-player-modal__panel {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  overflow-y: auto;
  overscroll-behavior: contain;
  background: #fff;
  border-radius: 28px;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.28);
  animation: trn-modal-pop 0.25s var(--bv-ease) both;
}

.trn-player-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 1.25rem;
}

.trn-player-modal__head h3 {
  margin: 10px 0 4px;
  font-family: var(--bv-font-display);
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--bv-ink);
}

.trn-player-modal__head p {
  margin: 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
}

/* close (X) button reuses .trn-player-remove */
.trn-player-modal__head .trn-player-remove {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: var(--bv-ink-3);
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.trn-player-modal__head .trn-player-remove:hover {
  background: #fff1f3;
  color: #e11d48;
}

.trn-player-modal .trn-player-grid {
  margin-bottom: 1.25rem;
}

/* name field takes the full row */
.trn-player-modal .trn-player-grid > label:first-child {
  grid-column: 1 / -1;
}

/* checkbox was inheriting the big text-input styles — reset it */
.trn-player-grid input[type="checkbox"] {
  width: 18px;
  height: 18px;
  min-width: 18px;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  box-shadow: none;
  accent-color: var(--bv-primary);
  cursor: pointer;
  flex-shrink: 0;
}

.trn-player-modal .trn-player-modal__captain {
  align-self: end;
  min-height: 54px;
  cursor: pointer;
  font-weight: 700;
  color: var(--bv-primary-700);
}

.trn-player-modal__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding-top: 1.25rem;
  border-top: 1px solid var(--bv-line-soft);
}

/* ---------- Summary sidebar ---------- */
.trn-register-aside {
  position: sticky;
  top: var(--trn-sticky-top, 96px);
}

.trn-register-summary {
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  border-radius: 28px;
  padding: 1.5rem;
  box-shadow: var(--bv-shadow-xs);
}

.trn-register-summary h2 {
  font-family: var(--bv-font-display);
  font-size: 1.25rem;
  font-weight: 800;
  margin: 0 0 1rem;
}

.trn-register-summary dl {
  display: grid;
  gap: 14px;
  margin: 0 0 1.25rem;
}

.trn-register-summary div {
  display: grid;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--bv-line-soft);
}

.trn-register-summary dt {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--bv-muted-2);
  font-weight: 700;
}

.trn-register-summary dd {
  margin: 0;
  color: var(--bv-ink);
  font-weight: 600;
}

.trn-register-summary__fee {
  color: var(--bv-primary);
  font-family: var(--bv-font-display);
  font-size: 1.5rem;
  font-weight: 800;
}

.trn-register-summary__cta {
  width: 100%;
  justify-content: center;
}

.trn-register-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
}

.trn-register-note i {
  color: var(--bv-primary);
}

.trn-register-error {
  color: #e11d48;
  font-weight: 600;
  font-size: 0.78rem;
  line-height: 1.3;
}

.trn-register-mobile-pay {
  display: none;
}

/* ---------- Success / login state ---------- */
.trn-register-success {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  border-radius: 32px;
  padding: 3rem 1.5rem;
  border: 1px solid var(--bv-line-soft);
}

.trn-register-success__icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 1rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: 1.8rem;
}

.trn-register-success h2 {
  font-family: var(--bv-font-display);
  font-weight: 800;
}

.trn-register-success__actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 1.5rem;
}

.trn-register-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: var(--bv-radius-pill);
  border: 1px solid var(--bv-line);
  background: #fff;
  color: var(--bv-ink);
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.trn-register-ghost:hover {
  border-color: var(--bv-primary-line);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}

/* ---------- Animations ---------- */
@keyframes trn-modal-fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes trn-modal-pop {
  from { opacity: 0; transform: translateY(16px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes trn-modal-sheet {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .trn-player-modal__backdrop,
  .trn-player-modal__panel {
    animation: none;
  }
}

/* ---------- Responsive ---------- */
@media (max-width: 991.98px) {
  .trn-register-layout {
    grid-template-columns: 1fr;
  }

  .trn-register-aside {
    position: static;
    display: none;
  }

  .trn-register-mobile-pay {
    display: block;
  }

  .trn-register-mobile-pay .trn-hero__cta {
    width: 100%;
    justify-content: center;
  }

  .trn-register-card__head {
    flex-wrap: wrap;
  }

  .trn-register-add {
    margin-left: 0;
  }
}

@media (max-width: 767.98px) {
  .trn-register-grid,
  .trn-player-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575.98px) {
  /* modal becomes a bottom sheet on phones */
  .trn-player-modal {
    align-items: flex-end;
    padding: 0;
  }

  .trn-player-modal__panel {
    max-width: 100%;
    max-height: 92vh;
    max-height: 92dvh;
    border-radius: 24px 24px 0 0;
    animation: trn-modal-sheet 0.3s var(--bv-ease) both;
  }

  .trn-player-modal .trn-player-modal__captain {
    align-self: stretch;
  }

  .trn-player-modal__actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .trn-player-modal__actions .trn-register-ghost,
  .trn-player-modal__actions .trn-card__cta {
    width: 100%;
    justify-content: center;
  }

  .trn-player-row__meta small {
    white-space: normal;
    word-break: break-word;
  }
}

/* ---------- Read-only captain details ---------- */
.trn-register-field--full {
  grid-column: 1 / -1;
}

.trn-register-field input[readonly] {
  background: #eef2f5;
  color: var(--bv-ink-3);
  cursor: not-allowed;
}

.trn-register-field input[readonly]:focus {
  border-color: #dbe4ea;
  box-shadow: none;
  background: #eef2f5;
}`, "",{"version":3,"sources":["webpack://./src/css/tournament-register.css"],"names":[],"mappings":";;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb;2CACyC;AAC3C;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf;0CACwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf;;6CAE2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf;sCACoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;;sCAEoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,2CAA2C;EAC3C;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,mDAAmD;EACrD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["\n\n.trn-register-page {\n  padding-bottom: 4rem;\n}\n\n.trn-register-hero__body {\n  align-items: center;\n}\n\n.trn-register-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.trn-register-pills span {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  color: var(--bv-ink-3);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n}\n\n.trn-register-pills i {\n  color: var(--bv-primary);\n}\n\n.trn-register-section {\n  padding: clamp(1.5rem, 4vw, 3rem) 0 0;\n}\n\n.trn-register-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.9fr);\n  gap: clamp(1.25rem, 3vw, 2rem);\n  align-items: start;\n}\n\n.trn-register-form {\n  display: grid;\n  gap: 1.25rem;\n}\n\n.trn-register-card {\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  border-radius: 28px;\n  padding: clamp(1.25rem, 3vw, 1.75rem);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.trn-register-card__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 1.25rem;\n}\n\n.trn-register-card__head h2 {\n  font-family: var(--bv-font-display);\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  margin: 0 0 4px;\n  color: var(--bv-ink);\n}\n\n.trn-register-card__head p {\n  margin: 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n}\n\n.trn-register-step {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n/* ---------- Team form ---------- */\n.trn-register-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.trn-register-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.trn-register-field--file {\n  grid-column: 1 / -1;\n}\n\n.trn-register-field > label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.trn-player-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.trn-register-field label i {\n  color: var(--bv-primary);\n  margin-right: 6px;\n}\n\n.trn-register-field label em {\n  color: #e11d48;\n  font-style: normal;\n  margin-left: 4px;\n}\n\n.trn-register-field label span {\n  margin-left: auto;\n  font-weight: 500;\n  color: var(--bv-muted-2);\n  font-size: 0.75rem;\n}\n\n.trn-register-field input,\n.trn-player-grid input,\n.trn-player-grid select {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 16px;\n  border: 1px solid #dbe4ea;\n  background: #f7fafc;\n  color: var(--bv-ink);\n  font-weight: 500;\n  outline: none;\n  transition: border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.trn-register-field input:focus,\n.trn-player-grid input:focus,\n.trn-player-grid select:focus {\n  border-color: #0d9488;\n  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);\n  background: #fff;\n}\n\n/* red border on the input when its field shows an error */\n.trn-register-field:has(.trn-register-error) input,\n.trn-player-grid label:has(.trn-register-error) input {\n  border-color: #fca5a5;\n  background: #fff7f8;\n}\n\n.trn-register-upload {\n  position: relative;\n  min-height: 140px;\n  border: 1.5px dashed var(--bv-primary-line);\n  border-radius: 20px;\n  background: var(--bv-primary-50);\n  overflow: hidden;\n}\n\n.trn-register-upload input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.trn-register-upload img {\n  width: 100%;\n  height: 160px;\n  object-fit: contain;\n  background: #fff;\n}\n\n.trn-register-upload__placeholder {\n  height: 140px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: var(--bv-primary-700);\n}\n\n.trn-register-upload__placeholder i {\n  font-size: 1.4rem;\n}\n\n.trn-register-add {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px solid var(--bv-primary-line);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  border-radius: var(--bv-radius-pill);\n  font-weight: 700;\n  font-size: var(--bv-text-sm);\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.trn-register-add:hover {\n  background: #fff;\n  transform: translateY(-1px);\n}\n\n/* ---------- Legacy player cards (kept for compatibility) ---------- */\n.trn-register-players {\n  display: grid;\n  gap: 1rem;\n}\n\n.trn-player-card {\n  border: 1px solid var(--bv-line-soft);\n  border-radius: 22px;\n  padding: 1rem;\n  background: linear-gradient(180deg, #fff 0%, #f8fbfb 100%);\n}\n\n.trn-player-card.is-captain {\n  border-color: var(--bv-primary-line);\n  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.08);\n}\n\n.trn-player-card header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.trn-player-card h3 {\n  margin: 0;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.trn-player-card h3 span {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: 0.7rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.trn-player-card header p {\n  margin: 4px 0 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n}\n\n.trn-player-remove {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  color: #e11d48;\n}\n\n.trn-player-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.trn-player-role {\n  border: 0;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-end;\n}\n\n.trn-player-role legend {\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.trn-player-role__option {\n  display: inline-flex;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n}\n\n/* ---------- Squad list ---------- */\n.trn-player-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 6px;\n  padding: 2rem 1rem;\n  border: 1.5px dashed var(--bv-primary-line);\n  border-radius: 20px;\n  background: var(--bv-primary-50);\n}\n\n.trn-player-empty i {\n  font-size: 1.6rem;\n  color: var(--bv-primary);\n  margin-bottom: 4px;\n}\n\n.trn-player-empty h3 {\n  margin: 0;\n  font-family: var(--bv-font-display);\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.trn-player-empty p {\n  margin: 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n}\n\n.trn-player-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.trn-player-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--bv-line-soft);\n  border-radius: 20px;\n  background: linear-gradient(180deg, #fff 0%, #f8fbfb 100%);\n}\n\n.trn-player-row.is-captain {\n  border-color: var(--bv-primary-line);\n  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.08);\n}\n\n.trn-player-row__avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n}\n\n.trn-player-row__meta {\n  flex: 1;\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.trn-player-row__meta strong {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  color: var(--bv-ink);\n  font-size: 0.95rem;\n}\n\n.trn-player-row__meta strong span {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: 0.68rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.trn-player-row__meta small {\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.trn-player-row__actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.trn-player-row__actions button {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  color: var(--bv-ink-3);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease);\n}\n\n.trn-player-row__actions button:hover {\n  background: var(--bv-primary-50);\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-700);\n}\n\n.trn-player-row__actions button.is-danger {\n  color: #e11d48;\n}\n\n.trn-player-row__actions button.is-danger:hover {\n  background: #fff1f3;\n  border-color: #fecdd3;\n  color: #be123c;\n}\n\n/* ---------- Add / Edit player modal ---------- */\n.trn-player-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n/* backdrop is a <button>, so reset native button styles */\n.trn-player-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  cursor: pointer;\n  animation: trn-modal-fade 0.2s ease both;\n}\n\n.trn-player-modal__panel {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: #fff;\n  border-radius: 28px;\n  padding: clamp(1.25rem, 3vw, 1.75rem);\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.28);\n  animation: trn-modal-pop 0.25s var(--bv-ease) both;\n}\n\n.trn-player-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 1.25rem;\n}\n\n.trn-player-modal__head h3 {\n  margin: 10px 0 4px;\n  font-family: var(--bv-font-display);\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--bv-ink);\n}\n\n.trn-player-modal__head p {\n  margin: 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n}\n\n/* close (X) button reuses .trn-player-remove */\n.trn-player-modal__head .trn-player-remove {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  color: var(--bv-ink-3);\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.trn-player-modal__head .trn-player-remove:hover {\n  background: #fff1f3;\n  color: #e11d48;\n}\n\n.trn-player-modal .trn-player-grid {\n  margin-bottom: 1.25rem;\n}\n\n/* name field takes the full row */\n.trn-player-modal .trn-player-grid > label:first-child {\n  grid-column: 1 / -1;\n}\n\n/* checkbox was inheriting the big text-input styles — reset it */\n.trn-player-grid input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  padding: 0;\n  margin: 0;\n  border-radius: 6px;\n  box-shadow: none;\n  accent-color: var(--bv-primary);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.trn-player-modal .trn-player-modal__captain {\n  align-self: end;\n  min-height: 54px;\n  cursor: pointer;\n  font-weight: 700;\n  color: var(--bv-primary-700);\n}\n\n.trn-player-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n/* ---------- Summary sidebar ---------- */\n.trn-register-aside {\n  position: sticky;\n  top: var(--trn-sticky-top, 96px);\n}\n\n.trn-register-summary {\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  border-radius: 28px;\n  padding: 1.5rem;\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.trn-register-summary h2 {\n  font-family: var(--bv-font-display);\n  font-size: 1.25rem;\n  font-weight: 800;\n  margin: 0 0 1rem;\n}\n\n.trn-register-summary dl {\n  display: grid;\n  gap: 14px;\n  margin: 0 0 1.25rem;\n}\n\n.trn-register-summary div {\n  display: grid;\n  gap: 4px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.trn-register-summary dt {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--bv-muted-2);\n  font-weight: 700;\n}\n\n.trn-register-summary dd {\n  margin: 0;\n  color: var(--bv-ink);\n  font-weight: 600;\n}\n\n.trn-register-summary__fee {\n  color: var(--bv-primary);\n  font-family: var(--bv-font-display);\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n.trn-register-summary__cta {\n  width: 100%;\n  justify-content: center;\n}\n\n.trn-register-note {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 12px 0 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n}\n\n.trn-register-note i {\n  color: var(--bv-primary);\n}\n\n.trn-register-error {\n  color: #e11d48;\n  font-weight: 600;\n  font-size: 0.78rem;\n  line-height: 1.3;\n}\n\n.trn-register-mobile-pay {\n  display: none;\n}\n\n/* ---------- Success / login state ---------- */\n.trn-register-success {\n  max-width: 640px;\n  margin: 0 auto;\n  text-align: center;\n  background: #fff;\n  border-radius: 32px;\n  padding: 3rem 1.5rem;\n  border: 1px solid var(--bv-line-soft);\n}\n\n.trn-register-success__icon {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 1rem;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: 1.8rem;\n}\n\n.trn-register-success h2 {\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n}\n\n.trn-register-success__actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 1.5rem;\n}\n\n.trn-register-ghost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 18px;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  color: var(--bv-ink);\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n  transition: border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.trn-register-ghost:hover {\n  border-color: var(--bv-primary-line);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n\n/* ---------- Animations ---------- */\n@keyframes trn-modal-fade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes trn-modal-pop {\n  from { opacity: 0; transform: translateY(16px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes trn-modal-sheet {\n  from { transform: translateY(100%); }\n  to   { transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .trn-player-modal__backdrop,\n  .trn-player-modal__panel {\n    animation: none;\n  }\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 991.98px) {\n  .trn-register-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .trn-register-aside {\n    position: static;\n    display: none;\n  }\n\n  .trn-register-mobile-pay {\n    display: block;\n  }\n\n  .trn-register-mobile-pay .trn-hero__cta {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .trn-register-card__head {\n    flex-wrap: wrap;\n  }\n\n  .trn-register-add {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .trn-register-grid,\n  .trn-player-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 575.98px) {\n  /* modal becomes a bottom sheet on phones */\n  .trn-player-modal {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .trn-player-modal__panel {\n    max-width: 100%;\n    max-height: 92vh;\n    max-height: 92dvh;\n    border-radius: 24px 24px 0 0;\n    animation: trn-modal-sheet 0.3s var(--bv-ease) both;\n  }\n\n  .trn-player-modal .trn-player-modal__captain {\n    align-self: stretch;\n  }\n\n  .trn-player-modal__actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .trn-player-modal__actions .trn-register-ghost,\n  .trn-player-modal__actions .trn-card__cta {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .trn-player-row__meta small {\n    white-space: normal;\n    word-break: break-word;\n  }\n}\n\n/* ---------- Read-only captain details ---------- */\n.trn-register-field--full {\n  grid-column: 1 / -1;\n}\n\n.trn-register-field input[readonly] {\n  background: #eef2f5;\n  color: var(--bv-ink-3);\n  cursor: not-allowed;\n}\n\n.trn-register-field input[readonly]:focus {\n  border-color: #dbe4ea;\n  box-shadow: none;\n  background: #eef2f5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
